import { createFileRoute } from '@tanstack/react-router'

import BppDashboardPage from '@/components/pages/backoffice/_dashboard/containers/BppDashboardPage'
import NewDashboardPage from '@/components/pages/backoffice/_dashboard/containers/NewDashboardPage'
import DashboardWelcome from '@/components/pages/backoffice/_dashboard/components/DashboardWelcome'
import EmailVerificationAlert from '@/components/pages/backoffice/_dashboard/components/EmailVerificationAlert'
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList
} from '@/components/ui/breadcrumb'
import MaxWidthDiv from '@/components/ui/max-width-div'
import { useAuth } from '@/hooks/use-auth'

export const Route = createFileRoute('/_backoffice/dashboard/')({
  component: RouteComponent,
  loader: ({ context: { profile } }) => {
    return { profile }
  }
})

function DashboardBreadcrumb() {
  return (
    <Breadcrumb>
      <BreadcrumbList>
        <BreadcrumbItem>
          <span className="text-sm font-medium text-gray-800">Dashboard</span>
        </BreadcrumbItem>
      </BreadcrumbList>
    </Breadcrumb>
  )
}

function RouteComponent() {
  const { profile: loaderProfile } = Route.useLoaderData()
  const { profile: liveProfile } = useAuth()
  const profile = liveProfile ?? loaderProfile
  const isPenyuluh = profile?.roles?.some(role => role.name === 'penyuluh')
  const isAdminBpp = profile?.roles?.some(role => role.name === 'admin_bpp')

  return (
    <MaxWidthDiv className="space-y-5">
      <DashboardBreadcrumb />
      <EmailVerificationAlert profile={profile} />
      <DashboardWelcome profile={profile} />
      {isPenyuluh && <NewDashboardPage />}
      {isAdminBpp && <BppDashboardPage />}
    </MaxWidthDiv>
  )
}
